import {
  getBossCounterAttack,
  getBossIntent,
  getBossRoundHealth,
} from './boss';

export const getCoreCounterplay = (name) =>
  ({
    'Static barrage':
      'Guard and shields can blunt the barrage. Aim for a shield or Interference tile.',
    Worldbreaker:
      'Heavy hit ahead. Guard reduces damage; Overload adds 3 if it hits. Save a decoy for danger.',
    'Siphon pulse':
      'Deny the heal: a full block or decoy stops Siphon restoring 80 Core HP.',
  }[name] || 'Check the damage faces before choosing your attack style.');

// Evaluate every announced face and landing, never the hidden pre-rolled result.
// Reuse the combat rules so shields, sabotage, backlash and decoys agree with play.
export const getCoreThreat = (game) => {
  const faces = getBossIntent(game).faces;
  const board = game.bossDoorBoard || [];
  const health = getBossRoundHealth(game);
  const losses = [];
  faces.forEach((bossRoll) => {
    board.forEach((_, bossLandingIndex) => {
      const counter = getBossCounterAttack({
        ...game,
        bossRoll,
        bossLandingIndex,
        bossRoundState: game.bossRoundState
          ? { ...game.bossRoundState, lockedCounter: null, lockedHealth: null }
          : null,
      });
      losses.push(counter.damage);
    });
  });
  const min = losses.length ? Math.min(...losses) : 0;
  const max = losses.length ? Math.max(...losses) : 0;
  return { min, max, lethal: max > 0 && max >= health.hpAfterHealing };
};

export const getBossMoment = (game, stage, attack, counter) => {
  if (['playerImpact', 'playerOutcome'].includes(stage)) {
    if (attack.frozen) return 'FROZEN · CORE ATTACKS TWICE';
    if (attack.critical && attack.damage > 0) return 'CRITICAL STRIKE';
    if (attack.damage >= 100) return `HEAVY HIT · ${attack.damage} DAMAGE`;
    if (
      game.bossBattleStats?.biggestHit > 0 &&
      attack.damage > game.bossBattleStats.biggestHit
    )
      return `NEW FIGHT BEST · ${attack.damage} DAMAGE`;
  }
  if (['bossImpact', 'bossOutcome'].includes(stage)) {
    if (counter.decoyIntercepted)
      return counter.damage > 0
        ? 'DECOY BLOCKED ONE ATTACK'
        : 'DECOY INTERCEPTION';
    if (counter.protocolSaved) return 'LAST STAND · STILL IN THE FIGHT';
    if (counter.rawDamage > 0 && counter.damage === 0)
      return getBossIntent(game).heal > 0
        ? 'PERFECT DEFENSE · SIPHON DENIED'
        : 'PERFECT DEFENSE';
  }
  return null;
};
